import React from 'react';

const PurchaseReport = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between !mt-0">
        <h1 className="text-2xl font-bold text-light-darkGrey font-roboto cursor-default">
          Purchase Report
        </h1>
      </div>
      {/* Add Purchase Report page content here */}
      <p>Purchase Report page content will go here.</p>
    </div>
  );
};

export default PurchaseReport;